import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@services/route.service";
import { tap } from "rxjs";

const CODE_LIMITED_SCAN: number=100;

export const offerInterceptor: HttpInterceptorFn=(req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router=inject(Router);
  return next(req).pipe(
    // we catch the error
    tap({
      error: (errorResponse: HttpErrorResponse) => {
        const error: any=errorResponse.error;

        //redirection vers la page d'offre
        if(error?.data && error.data?.code==CODE_LIMITED_SCAN)
          router.navigate('licence-offers');
      }
    })
  );
};